<script>
	// import LazyImg from "../components/LazyImg.svelte";
	import LazyImgResponsive from "../components/LazyImgResponsive.svelte";

	export let id;
	export let src = "";
	export let srcDesktop = undefined;
	export let srcTablet = undefined;
	export let srcMobile = undefined;
	export let width = "";
	export let height = "";
	export let responsive = false;
	export let hideOn = [];
	export let widthDesktop = undefined;
	export let heightDesktop = undefined;
	export let widthTablet = undefined;
	export let heightTablet = undefined;
	export let widthMobile = undefined;
	export let heightMobile = undefined;
	export let fadeToTransparent = false;
	export let minWidth = "";
	export let maxWidth = "";
	export let minHeight = "";
	export let maxHeight = "";

	responsive = responsive || hideOn.length > 0;

	const suffix = ".jpg";

	width = height ? "unset" : `${width}`;
	height = `${height}`;

	const hideOnDesktop = responsive && hideOn.includes("desktop");
	const hideOnTablet = responsive && hideOn.includes("tablet");
	const hideOnMobile = responsive && hideOn.includes("mobile");

	if (responsive) {
		srcDesktop = responsive && !hideOnDesktop ? `${src}_desktop` : null;
		// srcTablet = responsive && !hideOnTablet ? `${src}_desktop` : null;
		// srcMobile = responsive && !hideOnMobile ? `${src}_desktop` : null;
		srcTablet = responsive && !hideOnTablet ? `${src}_tablet` : null;
		srcMobile = responsive && !hideOnMobile ? `${src}_mobile` : null;
		src = null;
	} else {
		srcDesktop = `${src}_desktop`;
		srcTablet = `${src}_desktop`;
		srcMobile = `${src}_desktop`;
		src = `${src}${suffix}`;

		widthDesktop = undefined;
		heightDesktop = undefined;
		widthTablet = undefined;
		heightTablet = undefined;
		widthMobile = undefined;
		heightMobile = undefined;
	}

	if (srcDesktop) srcDesktop = `${srcDesktop}${suffix}`;
	if (srcTablet) srcTablet = `${srcTablet}${suffix}`;
	if (srcMobile) srcMobile = `${srcMobile}${suffix}`;
</script>

<div
	class="spread"
	class:fadeToTransparent25={fadeToTransparent === "25%"}
	class:fadeToTransparent50={fadeToTransparent === "50%"}
	class:fadeToTransparent={typeof fadeToTransparent !== "string" && fadeToTransparent}
>
	<LazyImgResponsive
		{id}
		class="spread"
		{src}
		{srcDesktop}
		{srcTablet}
		{srcMobile}
		style="width: {width}; height:{height}; max-width: {maxWidth}; min-width: {minWidth}; max-height: {maxHeight}; min-height: {minHeight}"
		styleDesktop="width: {widthDesktop}; height:{heightDesktop};"
		styleTablet="width: {widthTablet}; height:{heightTablet};"
		styleMobile="width: {widthMobile}; height:{heightMobile};"
		{hideOn}
	/>

	<div
		class="gradient left"
		class:hide-on-desktop={hideOnDesktop}
		class:hide-on-tablet={hideOnTablet}
		class:hide-on-mobile={hideOnMobile}
	/>
	<div
		class="gradient right"
		class:hide-on-desktop={hideOnDesktop}
		class:hide-on-tablet={hideOnTablet}
		class:hide-on-mobile={hideOnMobile}
	/>
</div>

<style lang="scss">
	.spread {
		position: relative;
		width: fit-content;
		height: fit-content;
		box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.15);
	}

	.fadeToTransparent {
		-webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 20%, rgba(0, 0, 0, 0) 100%);
		mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 20%, rgba(0, 0, 0, 0) 100%);
	}

	.fadeToTransparent25 {
		-webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 0) 100%);
		mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 0) 100%);
	}

	.fadeToTransparent50 {
		-webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%);
		mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%);
	}

	.gradient {
		width: 50px;
		height: 100%;
		position: absolute;
		top: 0;
		background: linear-gradient(90deg, #d9d9d9 0%, rgba(217, 217, 217, 0) 100%);
		opacity: 0.2;

		&.left {
			left: 0;
		}

		&.right {
			left: 50%;
		}
	}
</style>
